import { render, staticRenderFns } from "./ApexHistogram.vue?vue&type=template&id=22196ac6&scoped=true"
import script from "./ApexHistogram.vue?vue&type=script&lang=js"
export * from "./ApexHistogram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22196ac6",
  null
  
)

export default component.exports